import React from 'react';

import { cn } from '@lyearn/style';
import { Slider } from '@lyearn/ui';

import { markLabelStyles, markStyles, railStyles, sliderStyles, thumbStyles } from '../styles';

function SliderRating({
  max,
  min,
  value,
  onChange,
  disabled,
  name,
  step = 1,
  marks,
}: {
  max?: number;
  min?: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  name?: string;
  step?: number | null;
  marks?: { value: number; label: string }[];
}) {
  const handleChange = (event: Event, value: number | number[], activeThumb: number) => {
    onChange(value as number);
  };

  return (
    <Slider
      classes={{
        root: cn('w-auto ms-16 me-32 !h-[1rem]', sliderStyles),
        rail: railStyles,
        thumb: thumbStyles,
        mark: markStyles,
        markLabel: markLabelStyles,
      }}
      disabled={disabled}
      marks={marks}
      max={max}
      min={min}
      name={name}
      step={step}
      value={value}
      onChange={handleChange}
    />
  );
}

export default SliderRating;
